// # policies
import { PollPolicy } from '@/policies';
// # services
import { auth } from '@/services';

(function (angular) {
    'use strict';

    angular.module('app')
        .controller('pollsController', pollsController);

    pollsController.$inject = [
        '$rootScope',
        'Polls',
        'PollsApi',
        'pollsPayload',
        'alerts',
        'Helpers',
        '$scope',
        '$location',
        'PollVotesApi',
        'thisUser'
    ];

    function pollsController(
        $rootScope,
        Polls,
        PollsApi,
        pollsPayload,
        alerts,
        Helpers,
        $scope,
        $location,
        PollVotesApi,
        thisUser,

    ) {
        var vm = this;
        vm.limit = 9;
        const nowISO = window.moment().format(Helpers.isoFormat);

        // properties
        vm.permissionChecks = {
            canCreate: PollPolicy.canCreate(auth.user()),
        };
        vm.categories = [].concat($location.search()['categories[]'] || []).map(id => parseInt(id));
        vm.polls = pollsPayload;
        vm.filters = {
            "categories[]": vm.categories,
            page: 1,
            starts_at_from: nowISO,
            voted_as: ($rootScope.thisUser ? $rootScope.thisUser.id : null),
            with: 'pollOptions',
            hide_if_child: true,
            type: 'poll',
        };
        vm.orderFilters = {
            ascending: {
                label: 'Ascending',
                sort: 'starts_at',
                order: 'asc',
                starts_at_from: nowISO,
                ends_at_from: null,
            },
            descending: {
                label: 'Descending',
                sort: 'starts_at',
                order: 'desc',
                starts_at_from: nowISO,
                ends_at_from: null,
            },
        };
        vm.selectedOrderFilter = vm.orderFilters.ascending;

        // methods
        vm.onCategoryChange = onCategoryChange;
        vm.getPolls = getPolls;
        vm.orderPolls = orderPolls;
        vm.createPoll = createPoll;
        vm.pollStatus = pollStatus;

        pollStatus();

        /**
         * Called when categories have changed.
         * @param categories
         */
        function onCategoryChange(categories: string[]): void {
            vm.categories = categories;
            vm.filters["categories[]"] = categories;

            vm.getPolls();
        }

        /**
         * Retrieves polls from the API
         * @return {void}
         */
        function getPolls() {
            vm.isLoading = true;
            PollsApi.get(
                vm.filters,
                function handleGetPollsResponse(response) {
                    vm.polls = response;
                    vm.isLoading = false;
                },
                function handleGetPollsError() {
                    vm.isLoading = false;
                }
            );
        }

        /**
        * Gets the polls and goes through them to set status
        */
        function pollStatus() {
            if (vm.polls == null) {
                getPolls();
            }
            //loop over each poll
            vm.polls.data.forEach(poll => {

                const data = {
                    poll_id: poll.id,
                    user_id: thisUser ? thisUser.id : null,
                };

                //search the poll votes here
                //consider putting this in an await?
                PollVotesApi.get(data, function (response) {
                    if (response.data != null) {
                        // eslint-disable-next-line no-param-reassign
                        poll.selectedOption = {
                            id: response.data.poll_option_id,
                            status: response.data.status,
                        };
                    }
                });
            });
        }

        /**
         * Updates filters and refreshes the polls.
         * Called by the order polls select control.
         *
         * @return {void}
         */
        function orderPolls() {
            angular.merge(vm.filters, vm.selectedOrderFilter);
            vm.filters.label = null;
            getPolls();
        }
        $scope.loadMore = function() {
            var increamented = vm.limit + 3;
            vm.limit = increamented > vm.polls.length ? vm.polls.length : increamented;
          };

        /**
         * Calls create poll service, and appends new poll to the page
         * @return {void}
         */
        function createPoll() {
            Polls.managePoll();
        }
    }

}(angular));
